import { Component, Input } from '@angular/core';

@Component({
  selector: 'adc-tooltip',
  templateUrl: './adc-tooltip.component.html',
  styleUrls: ['./adc-tooltip.component.scss'],
  standalone: false
})
export class AdcTooltipComponent {
  @Input() tooltipText!: string;

  onMouseOver(event: MouseEvent){
    const target = event.target as HTMLElement;
    // const tooltipText = target.getAttribute('data-tooltip');
    const tooltipRect = target.getBoundingClientRect();
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      let position = '';
  
      if (tooltipRect.top < centerY) {
        position = 'bottom';
      } else {
        position = 'top';
      }
  
      if (tooltipRect.left > centerX) {
        position += ' left';
      } else {
        position += ' right';
      }
  
      target.setAttribute("data-position", position);
      console.log(target.getAttribute("data-position"));
    
  }
}
